import api from '@/lib/api';
import type { AdminActivityListResponse } from '@/types/admin';

export interface ActivityQuery {
  userId?: string;
  organizationId?: string;
  type?: string;
  from?: string;
  to?: string;
  page?: number;
  perPage?: number;
}

export async function fetchActivity(params: ActivityQuery): Promise<AdminActivityListResponse> {
  const { data } = await api.get('/admin/activity', { params });
  const body = data as AdminActivityListResponse & { data?: AdminActivityListResponse };
  return body.data ?? body;
}
